import axios, { type AxiosProgressEvent, type AxiosRequestConfig } from 'axios';
import { useUserData } from '@/stores/userData';
import { computed } from 'vue';
import type { IPostIdea, IAuth, IValidatePoints, IUsersLoad, IPostEventToExcell, IPostIdeaPdf, IPeerTransaction } from
    '@/interfaces/IPostFetch';
import type { IPointsForm, INewActivityData, IPurchaseMerchData } from '@/interfaces/IPutFetchData';
import type { IPostCardMsg, INeuroChat } from '@/interfaces/IEntities';
import type { IPostInner } from '@/components/tools/common/PostInner.vue';
import { type ISortItems } from '@/interfaces/IEntities';
import type { INotificationBroadcast } from '@/interfaces/IPostFetch';

const defaultUrl = (import.meta.env.VITE_API_URL).replace('/api', '');
const VITE_API_URL = import.meta.env.VITE_API_URL

const api = axios.create({
    baseURL: VITE_API_URL,
    withCredentials: true,
})

const vendorApi = axios.create({
    withCredentials: true,
})

// добавляю токен
const authCookie = computed(() => useUserData().getAuthKey);
const id = computed(() => useUserData().getMyId);

api.interceptors.request.use((config) => {
    config.headers.session_id = authCookie.value || '';
    return config
})
vendorApi.interceptors.request.use((config) => {
    config.headers.session_id = authCookie.value || '';
    config.headers.user_id = id.value;
    return config
})


export default class Api {
    static async get(url: string, config?: AxiosRequestConfig | null, signal?: AbortSignal) {
        const mergedConfig: AxiosRequestConfig = { ...config, signal: signal ?? config?.signal }
        return await api.get(url, mergedConfig)
            .then(resp => resp.data)
            .catch(e => {
                if (e.status == 502) {
                    window.location.href = `${defaultUrl}/inservice`
                }
                else if (e.status == 401) {
                    useUserData().logOut()
                    throw new Error('Сессия истекла. Необходимо войти в систему заново.')
                }
            })
    }

    static async getVendor(url: string, config?: AxiosRequestConfig) {
        return await vendorApi.get(url, config)
            .then(resp => resp.data)
    }

    static async postVendor(url: string, data: INeuroChat[] | null | FormData) {
        return (await vendorApi.post(url, data)).data
    }

    static async post(
        url: string,
        data?:
            | IAuth
            | INotificationBroadcast
            | IPostIdea
            | IPostInner
            | FormData
            | IPostCardMsg
            | IValidatePoints
            | IPeerTransaction
            | INewActivityData
            | IUsersLoad
            | Array<IPostEventToExcell>
            | Array<string>
            | IPostIdeaPdf
            | { art_id: string | null | undefined; links: string[]; }
            | null,
        config?: AxiosRequestConfig & {
            onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
        }
    ) {
        return await api.post(url, data, config)
            .then(resp => config ? resp : resp.data)
            .catch(e => {
                if (e.status == 502) {
                    window.location.href = `${defaultUrl}/inservice`
                }
                else if (e.status == 401) {
                    useUserData().logOut()
                    throw new Error('Сессия истекла. Необходимо войти в систему заново.')
                }
            })
    }

    static async put(
        url: string,
        data?: number[] | IPointsForm | INewActivityData | IPurchaseMerchData | ISortItems[],
    ) {
        return (await api.put(url, data)).data
    }

    static async delete(url: string, data?: number[]) {
        return await api.delete(url, { data })
    }
}
